import { InterFaceCertificate } from '../components/certificate/InterFaceCertificate'

const certificate: InterFaceCertificate.Payload = {
    data: [
        {
            title : '정보처리기사',
            date : '2019. 08'
        },
        {
            title : 'SQL 개발자',
            date : '2019. 04'
        },
        {
            title : '데이터 분석 준전문가',
            date : '2018. 12'
        },
        {
            title : '품질경영기사',
            date : '2018. 08'
        },        
    ]
}

export default certificate;
